import { ref } from "vue";

const visible = ref(false);
const message = ref("");
const type = ref("default");
let timeout = null;

export function useToast() {
  const hideToast = () => {
    visible.value = false; // visible만 false로 변경
  };

  const showToast = (msg, options = {}) => {
    // 이전 타이머가 있다면 제거
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    // 새 메시지로 업데이트하고 즉시 표시
    message.value = msg;
    type.value = options.type || "default";
    visible.value = true;

    // 새로운 타이머 설정
    timeout = setTimeout(() => {
      hideToast();
      timeout = null;
    }, options.duration || 3000);
  };

  return {
    visible,
    message,
    type,
    showToast,
    hideToast,
  };
}
